var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useContext } from "@wordpress/element";
import { createPipelineRequest } from "../../../../api/api";
import { CLOSE_PIPELINE_MODAL, PIPELINE_ADD_PIPELINE, } from "../../../../constants";
import { ModalContext } from "../../../../providers/ModalContextProvider";
import { WPQTModal } from "../../WPQTModal";
import { PipelineModalContent } from "./AddPipelineModalContent";
import { DispatchType, useModal } from "../../../../hooks/useModal";
import { ActivePipelineContext } from "../../../../providers/ActivePipelineContextProvider";
function AddPipelineModal() {
    const { state: { newPipelineModalOpen }, } = useContext(ModalContext);
    const { fetchAndSetPipelineData } = useContext(ActivePipelineContext);
    const { modalSaving, setModalSaving, modalContentRef, closeModal, handleSuccess, handleError, } = useModal(CLOSE_PIPELINE_MODAL);
    const addPipeline = (pipelineName, pipelineDescription) => __awaiter(this, void 0, void 0, function* () {
        try {
            setModalSaving(true);
            const response = yield createPipelineRequest(pipelineName, pipelineDescription);
            handleSuccess(PIPELINE_ADD_PIPELINE, response.data, DispatchType.PIPELINES);
            fetchAndSetPipelineData(response.data.id);
        }
        catch (error) {
            handleError(error);
        }
    });
    return (_jsx(WPQTModal, { modalOpen: newPipelineModalOpen, closeModal: closeModal, children: _jsx(PipelineModalContent, { ref: modalContentRef, addPipeline: addPipeline, modalSaving: modalSaving, setModalSaving: setModalSaving }) }));
}
export { AddPipelineModal };
